import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchPaymentDetails_api = async (
  cid: any = "",
  page = 1,
  limit = 10,
  search = "",
  isCredited = "",
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Payments/fetch_payment_details.php`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          customerId: cid || null,
          page,
          limit,
          search,
          isCredited,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    console.error("Fetch payment details failed:", error);
    return { error: "Fetch payment details failed" };
  }
};
